export const HIDE_COMMUNITY = true;
export const ENABLE_NEXT_YEAR_CROPS = true;

export const FEATURE_FLAG_SLUGS = {
  SOIL_PLUS_3_DATA_GAP: "soilPlus3DataGap",
  SOIL_PLUS_3_REWARDS: "soilPlus3Rewards",
  RESILIENCE_SCORE: "resilienceScore",
} as const;

export type FEATURE_FLAG_SLUGS_TYPE = (typeof FEATURE_FLAG_SLUGS)[keyof typeof FEATURE_FLAG_SLUGS];

export const FEATURE_FLAG_NAMES = {
  [FEATURE_FLAG_SLUGS.SOIL_PLUS_3_DATA_GAP]: "Soil+ 3.0 Data Gap Flow",
  [FEATURE_FLAG_SLUGS.SOIL_PLUS_3_REWARDS]: "Soil+ 3.0 Rewards Panel",
  [FEATURE_FLAG_SLUGS.RESILIENCE_SCORE]: "Resilience Score",
} as const;
